import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';


import { AppService } from '@app/services/app/app.service';
import { UrlService } from '@core/services/url/url.service';
import { TitleService } from '@core/services/title.service';

import { Request, BasicRequest } from '@core/objects/request';
import { File } from '@core/objects/file';

import { User } from '@core/objects/user';
import { Organization } from '@core/objects/organization';


@Component({
    selector: 'plugin-share-transfer-main-app',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class PluginShareTransferMainAppComponent implements OnInit {

    readonly PLUGIN = "share_transfer";

    public readonly SIGNATURE_OPTION_TYPE_CFR11 = 'cfr11';

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;

    public readonly VIEW_SELECTOR = 0;
    public readonly VIEW_SENDER = 1;
    public readonly VIEW_DONE = 2;
    public readonly VIEW_FEEDBACK_ERROR = 3;
    public readonly VIEW_FEEDBACK_DONE = 4;

    public readonly NO_DETERMINED = 0;
    public readonly DEFAULT_MODE = 1;
    public readonly SINGLE_FILE_MODE = 2;
    public readonly SINGLE_VERSION_MODE = 3;

    public screenMode: number = this.NO_DETERMINED;
    public status: number = this.LOADING;
    public permission: boolean = true;
    public view: number = this.VIEW_SELECTOR;

    public request: Request = null;
    public requestHeader: BasicRequest = null;
    public versionId: number;
    public requestId: number;
    public fileId: number;
    public filesPluralPart: string = "";
    public signatureOption: boolean = false;

    // public files: SelectedFilesToTransfer = new SelectedFilesToTransfer();

    public filesSelected: Array<File> = [];
    //public form: FormGroup = new FormGroup({});
    public form: FormGroup;

    protected user: User;
    protected organization: Organization;
    public subject: string;

    public subscriptionRoutes: Subscription;
    private navigationSubscription: Subscription | undefined;
    private lastSuccessfulNavigation: NavigationEnd | undefined;

    constructor(private appSrv: AppService, 
        private http: HttpClient, 
        public urlSrv: UrlService, 
        private activeRoute: ActivatedRoute, 
        private title: TitleService,
        private location: Location,
        private router: Router) {
        // TODO: check options to select screen mode

        this.appSrv.getSession().subscribe(session => {
            this.user = session.current.user;
            this.organization = session.current.organization;
            this.signatureOption = session?.options?.organization.version_approvals_signature_type === this.SIGNATURE_OPTION_TYPE_CFR11;

            if(session.options.plugins.indexOf(this.PLUGIN) == -1)
                this.status = this.NOT_FOUND;
        });

        this.navigationSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              this.lastSuccessfulNavigation = event;
            }
        });
    }

    ngOnInit() {
        // load query params to check from where user came from
        this.subscriptionRoutes = this.activeRoute.queryParams.subscribe(params => {
            if ( params.file && params.version ) {
                this.versionId = Number(params.version);
                this.fileId = Number(params.file);
                this.screenMode = this.SINGLE_FILE_MODE;
                
            } else if( params.version ){
                this.versionId = Number(params.version);
                this.screenMode = this.SINGLE_VERSION_MODE;
            } else {
                this.screenMode = this.DEFAULT_MODE;
            }
            this.initView();
            
        });

        this.form =  new FormGroup({});

        this.requestId = Number(this.activeRoute.snapshot.paramMap.get('request'));

        this.title.set("Select files to send - Project #"+this.requestId);
        this.initView();
    }

    onChange(e) {
        if(e.length >=0)
            this.filesSelected = (e);
    }

    ngOnDestroy(){
        this.subscriptionRoutes.unsubscribe();
        if(this.navigationSubscription)
            this.navigationSubscription.unsubscribe();
    }

    protected initView(){
        // When no version or file in url work as default
        if((this.screenMode == this.DEFAULT_MODE || this.screenMode == this.SINGLE_VERSION_MODE ) && this.requestId){
            if(this.status != this.NOT_FOUND)
                this.loadRequest(this.requestId);
        }
        // NOT NEEDED feb-2024: reqeust is checked on backend 
        // When have only version in the url,
        // we need to check the origin request of the version
        // if( this.screenMode == this.SINGLE_VERSION_MODE && this.versionId && this.requestId){
        //     if(this.status != this.NOT_FOUND)
        //         this.checkOriginalRequest(this.versionId, this.requestId);                
        // }
        // When file & version in the url,
        // we need to check the version has this file  and then also the origin request of the version
        if( this.screenMode == this.SINGLE_FILE_MODE && this.fileId && this.versionId && this.requestId){
            if(this.status != this.NOT_FOUND)
                this.checkVersionFile(this.versionId,this.fileId);
        }
    }

    protected loadFile(id: Number) {
        this.http.get(this.urlSrv.build('/files/'+id)+"?f=json").subscribe({
            next: (data:File) => {
                this.filesSelected.push(data);
                this.view = this.VIEW_SENDER;
            },
            error: (error:any) => {
            }
        });
    }

    protected loadRequest(requestId: number){
        this.http.get(this.urlSrv.build('/requests/'+requestId)).subscribe({
            next: (data:Request) => {
                this.setRequest(data);
                this.status = this.DONE;
            },
            error: (error:any) => {
                this.loadRequestHeaders(requestId)
            }
        });
    }

    protected loadRequestHeaders(requestId: number){
        if(!requestId)
            return;
        this.http.get(this.urlSrv.build('/requests/'+requestId+'/headers')).subscribe({
            next: (data:BasicRequest) => {
                this.setRequestHeader(data);
                this.status = this.DONE;
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
            }
        });
    }
    
    // NOT NEEDED feb-2024: reqeust is checked on backend 
    // Check if the param in url is the original request of the version is correct.
    // protected checkOriginalRequest(versionId: number, requestId: number){
    //     this.http.get(this.urlSrv.build('/versions/'+versionId+'/request')).subscribe({
    //         next: (originalRequest:Request) => {

    //             if (originalRequest != null && originalRequest.id != requestId){
    //                 this.status = this.NOT_FOUND;
    //             } else {
    //                 this.loadRequest(requestId);
    //             }
    //         },
    //         error: (error:any) => {
    //             this.status = this.NOT_FOUND;
    //         }
    //     });
    // }

    // Check if the file param in url is a correct version file.
    protected checkVersionFile(versionId: number, fileId: number){
        this.http.get(this.urlSrv.build('/versions/'+versionId+'/files')).subscribe({
            next: (files:Array<File>) => {
                if (fileId != null && !files.some((vf: File) => vf.id == fileId)){
                    this.status = this.NOT_FOUND;
                } else {
                    this.loadFile(fileId);
                    this.loadRequest(this.requestId);
                    // NOT NEEDED feb-2024: reqeust is checked on backend 
                    // proceed to check origin request of the version.
                    // this.checkOriginalRequest(this.versionId, this.requestId);
                }
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
            }
        });
    }

    public setView(view: number)
    {
        this.view = view;
    }

    public setRequest(request: Request) {
        this.request = request;

        let labels = this.request.labels.map(l => l.name).join(", ");
        // update april 2024 -> Twona AMS - {User Owner name} is sending you file(s) related to {Request labels}
        // Twona AMS - prefix already set on backend
        this.subject = this.user.name +
            " is sending you file(s) related to " + labels;
    }

    public setRequestHeader(request: BasicRequest) {
        this.requestHeader = request;

        let labels = this.requestHeader.labels.map(l => l.name).join(", ");
        this.subject = this.user.name +
            " is sending you file(s) related to " + labels;
    }


    public onAddSignatureChange(e) {
        console.debug(" %%%  main transfer onSignatureChange");
    }

    public onSubmit() {
        let data = {
            type: "transfer",
            request: this.request? this.request.id : this.requestHeader.id,
            files: this.filesSelected.map((f: File) => f.id),
            subject: this.form.get('subject').value,
            message: this.form.get('message').value,
            emails: this.form.get('emails').value,
            with_signatures: this.form.get('with_signatures')?.value || false, // TODO maybe quit this property when no cfr11 in org
        }
        if(data.files.length >1 ) {
            this.filesPluralPart = 's';
        }
        this.http.post(this.urlSrv.build('/share'), data).subscribe({
            next: (data: any) => {
                this.view = this.VIEW_FEEDBACK_DONE;
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
                this.view = this.VIEW_FEEDBACK_ERROR;
            }
        });

        console.debug(" transfer submit ", data);

    }

    public cancel () {
        this.filesSelected = [];
    }
    // checks to show the button SEND
    isTransferReady () {
        return (
            this.filesSelected.length > 0 &&
            this.form.get('subject')?.value != '' &&
            this.form.get('emails')?.value?.length > 0 &&
            this.form.get('message')?.value?.length > 0
           )
    }
    // checks to show the button NEXT
    isSelectionReady() {
        return (this.filesSelected.length > 0);
    }
    // action when push modal buton when error
    onError() {
        console.debug(" Error modal clicked");
        this.view = this.VIEW_SENDER;
        this.status = this.DONE
    }

    onSent() {
        console.debug(" Sent modal clicked ");
        // this.view = this.VIEW_DONE;
        this.cancel();
        if (this.lastSuccessfulNavigation) {
            this.location.back();
        } else {
            console.debug('There is no previous navigation state.');
            this.view = this.VIEW_DONE;
        }
    }



}
